import { FC } from "react";
import { Box, Container, Flex, Link, Text } from "@radix-ui/themes";
import { Timestamp } from "@/api/firebase/firebase.config";
import {
  BookmarkIcon,
  CheckCircledIcon,
  ExternalLinkIcon,
} from "@radix-ui/react-icons";

interface SingleZoneFooterProps {
  logoURL: string;
  title: string;
  desc: string;
  created: Timestamp;
}

export const SingleZoneFooter: FC<SingleZoneFooterProps> = ({
  logoURL,
  title,
  desc,
  created,
}): JSX.Element => {
  return (
    <Container
      py={{ initial: "5", lg: "9" }}
      px={{ initial: "4", md: "2", xl: "0" }}
    >
      <Flex direction="column" gap="5">
        {/* Logo */}
        <Box>
          <img
            src={logoURL}
            alt={title}
            width={150}
            style={{
              width: "150px",
              height: "auto",
            }}
          />
        </Box>

        {/* Description */}
        <Text as="p">{desc}</Text>

        {/* Details */}
        <Flex direction="column" gap="2">
          {/* Verified */}
          <Flex direction="row" align="center" gap="2">
            <CheckCircledIcon />
            <Text size="2" color="gray">
              Verified zone
            </Text>
          </Flex>
          {/* Verified */}
          <Flex direction="row" align="center" gap="2">
            <BookmarkIcon />
            <Text size="2" color="gray">
              Member since {created.toDate().toDateString()}
            </Text>
          </Flex>
          {/* Link */}
          <Flex direction="row" align="center" gap="2">
            <ExternalLinkIcon />
            <Text size="2" color="gray">
              <Link
                color="gray"
                href="https://www.logitechg.com/"
                target="_blank"
              >
                https://www.logitechg.com
              </Link>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Container>
  );
};
